import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TrailFiltersState {
  sortBy: string;
  name: string;
  statusFilter: string;
  cityFilter: number[];
  countryFilter: number[];
}

const initialState: TrailFiltersState = {
  sortBy: '',
  name: '',
  statusFilter: '',
  cityFilter: [],
  countryFilter: [],
};

const trailFiltersSlice = createSlice({
  name: 'trailFilters',
  initialState,
  reducers: {
    setTrailFilters(state, action: PayloadAction<any>) {  
      state.name = action.payload.name;
      state.sortBy = action.payload.sortBy;
      state.statusFilter = action.payload.statusFilter;
      state.cityFilter = action.payload.cityFilter || [];
      state.countryFilter = action.payload.countryFilter || [];
    },
    setCountryFilter(state, action: PayloadAction<number[]>) {
      state.countryFilter = action.payload;
    },
    setCityFilter(state, action: PayloadAction<number[]>) {
      state.cityFilter = action.payload;
    },
  },
});

export const { setTrailFilters, setCountryFilter, setCityFilter } = trailFiltersSlice.actions;
export default trailFiltersSlice.reducer;
